import {
  Directive,
  Input,
  ElementRef,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  takeUntil,
} from 'rxjs/operators';

@Directive({
  selector: '[debounceInput]',
})
export class DebounceInputDirective implements OnInit, OnDestroy {
  // va a emitir el valor del input despues del debounce
  @Output() private onEventDebounce: EventEmitter<string>;

  // parametro para el tiempo de debounce en ms
  @Input() debounceTime: number = 300;

  // numero de caracteres que va a omitir antes de iniciar el proceso de debounce en el input
  @Input() private numberCharactersToSkipDebounce: number = 0;

  private _unsubscribeAll: Subject<void>;

  constructor(private elementRef: ElementRef) {
    this.onEventDebounce = new EventEmitter<string>();
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    fromEvent<any>(this.elementRef.nativeElement, 'keyup')
      .pipe(
        takeUntil(this._unsubscribeAll),
        map((event: Event) => {
          return (event.target as HTMLInputElement).value;
        }),
        filter((res) => res.length >= this.numberCharactersToSkipDebounce),
        debounceTime(this.debounceTime),
        distinctUntilChanged()
      )
      .subscribe({
        next: (term: string) => {
          this.onEventDebounce.emit(term);
        },
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
